import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import CampaignDetail from './CampaignDetail';
import CampaignOperationsSummaryPanel from './CampaignOperationsSummaryPanel';

const LIVE_STATUSES = new Set(['Active', 'Activating', 'Paused', 'Needs attention']);

export default function CampaignDetailOperationsShell() {
  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const mounted = useRef(true);

  const loadSummary = useCallback(async ({ silent = false } = {}) => {
    if (!id) return;
    if (!silent) setLoading(true);
    try {
      const [campaignResponse, summaryResponse] = await Promise.all([
        api.get(`/campaigns/${id}`),
        api.get(`/campaigns/${id}/operations-summary`),
      ]);
      if (!mounted.current) return;
      setCampaign(campaignResponse.data || null);
      setSummary(summaryResponse.data || null);
    } catch (error) {
      if (!mounted.current) return;
      // CampaignDetail owns the primary error state. Keep this enhancement non-blocking.
      console.warn('[CampaignOperationsShell] summary unavailable:', error?.response?.data || error.message);
    } finally {
      if (mounted.current && !silent) setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    mounted.current = true;
    loadSummary();
    return () => { mounted.current = false; };
  }, [loadSummary]);

  useEffect(() => {
    if (!LIVE_STATUSES.has(campaign?.status)) return undefined;
    const handle = setInterval(() => loadSummary({ silent: true }), 30_000);
    return () => clearInterval(handle);
  }, [campaign?.status, loadSummary]);

  const showOperations = campaign && campaign.status !== 'Concept' && campaign.status !== 'Archived';
  return <div className="bg-gray-50">
    {showOperations && <div className="px-4 pt-4 sm:px-6 lg:px-8"><CampaignOperationsSummaryPanel campaignId={id} summary={summary} loading={loading} onRefresh={() => loadSummary()} /></div>}
    <CampaignDetail />
  </div>;
}
